/**
 * Helpers for SIP paging zone create + Twilio SIP credential provisioning.
 */

export function extractSipUsername(uri) {
  const raw = String(uri || '').trim();
  if (!raw) return '';
  const withoutPrefix = raw.toLowerCase().startsWith('sip:') ? raw.slice(4) : raw;
  return withoutPrefix.split('@')[0].trim();
}

export function suggestSipUsername(name) {
  return String(name || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9._-]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);
}

export function normalizeSipDomain(domain) {
  return String(domain || '')
    .trim()
    .replace(/^sip:/i, '')
    .replace(/\/.*$/, '')
    .replace(/;.*$/, '');
}

export function buildSipUri(username, domain) {
  const user = String(username || '').trim();
  const host = normalizeSipDomain(domain);
  if (!user || !host) return '';
  return `sip:${user}@${host}`;
}

export function parseApiErrorMessage(error) {
  const msg = String(error?.message || error || '');
  const jsonStart = msg.indexOf('{');
  if (jsonStart === -1) return msg;
  try {
    const parsed = JSON.parse(msg.slice(jsonStart));
    return parsed.error || parsed.message || parsed.details || msg;
  } catch {
    return msg;
  }
}

export function isDuplicateSipUserError(error) {
  const text = parseApiErrorMessage(error).toLowerCase();
  return (
    text.includes('already exists') ||
    text.includes('already in use') ||
    text.includes('duplicate') ||
    text.includes('21210')
  );
}

export function findSipCredentialByUsername(credentials, username) {
  const needle = String(username || '').trim().toLowerCase();
  if (!needle) return null;
  const list = Array.isArray(credentials) ? credentials : [];
  return (
    list.find((item) => String(item?.username || '').trim().toLowerCase() === needle) ||
    null
  );
}

export function sipCredentialSid(credential) {
  const sid = String(credential?.credentialSid || credential?.id || '').trim();
  return sid || null;
}
